import { routes } from '@/config/routes';

export const categoryNavigation = [
  {
    label: 'Wood Engraving',
    description: 'Names, artwork, and memories etched into natural keepsakes.',
    icon: 'pi pi-box',
    to: routes.woodEngraving,
  },
  {
    label: 'Ornaments',
    description: 'Small personalized markers for your favorite holiday moments.',
    icon: 'pi pi-star',
    to: routes.ornaments,
  },
  {
    label: 'T-Shirts',
    description: 'Custom apparel for people, teams, and meaningful occasions.',
    icon: 'pi pi-palette',
    to: routes.tshirts,
  },
] as const;

export const primaryNavigation = [
  { label: 'Wood Engraving', to: routes.woodEngraving },
  { label: 'Ornaments', to: routes.ornaments },
  { label: 'T-Shirts', to: routes.tshirts },
  { label: 'How It Works', to: routes.howItWorks },
  { label: 'About', to: routes.about },
] as const;
